import { Text } from '@/components/Text';
import { LinkIcon } from '@/partials/dashboard/Cards/UpdateCard/UpdateCardLinks/LinkIcon';
import type { CardLink } from '@/types/card';

export interface SocialLinkProps {
  link: CardLink;
  onClick: () => void;
}

export const SocialLink = ({ link, onClick }: SocialLinkProps) => (
  <div
    className="group flex cursor-pointer flex-col items-center"
    onClick={onClick}
  >
    <div className="relative overflow-hidden p-2">
      <LinkIcon
        link={link}
        className="size-24"
        iconStyle="size-20 rounded-[20px] aspect-square shadow-md"
        emojiStyle="text-5xl size-20 rounded-[20px] aspect-square shadow-md"
      />
    </div>
    <Text className="text-center text-sm font-medium text-gray-dark transition-colors group-hover:text-linko-dark">
      {link.title || ''}
    </Text>
  </div>
);
